import type { KameleoonFeatureFlags } from './types';

const kameleoonFeaturesStorageKey = 'kameleoonFeatureFlags';

export const storeKameleoonFeatures = (features: KameleoonFeatureFlags) => {
    localStorage.setItem(kameleoonFeaturesStorageKey, JSON.stringify(features));
};
export const getKameleoonFeaturesFromStorage = (): KameleoonFeatureFlags => {
    const initialFeatures = localStorage.getItem(kameleoonFeaturesStorageKey) ?? '{}';
    const existingFeatures: KameleoonFeatureFlags = JSON.parse(initialFeatures) ?? {};

    return existingFeatures;
};
